import { VDataTable, VTextField, VImg, VIcon } from "vuetify/lib";
import goTo from "vuetify/lib/services/goto";

//import { v4 as uuidv4 } from "uuid";
import "../../overviewTables.scss";
import {
  updateSortValue,
  updateSortValuesFromQuery,
  highlight
} from "@/utils/helpers";

const nonSearchFields = ["foto", "id", "searchText", "typ"];

export default {
  props: ["target"],
  data() {
    return {
      search: "",
      sortBy: undefined,
      sortDesc: false,
      ordermode: ""
    };
  },
  created() {
    this.ordermode = "";
    if (
      this.$store.state.bestellungConfig.rendermode == "editorder" &&
      this.$store.state.bestellungConfig.fish &&
      this.$store.state.bestellungConfig.fish.length > 5
    ) {
      this.ordermode = "fisch";
    }
    if (
      this.$store.state.bestellungConfig.rendermode == "editorder" &&
      this.$store.state.bestellungConfig.consumable &&
      this.$store.state.bestellungConfig.consumable.length > 5
    ) {
      this.ordermode = "ware";
    }
  },
  mounted() {
    updateSortValuesFromQuery(this);
    if (
      this.$store.state.bestellungConfig.fish &&
      this.$store.state.bestellungConfig.fish != ""
    ) {
      goTo(".selectedTR", { container: ".v-data-table__wrapper" });
    }
  },
  watch: {
    search(value) {
      this.updateSortValue(this, "search", value);
    }
  },
  beforeDestroy() {},
  computed: {
    filteredList() {
      return this.$store.state.lookup.warenfische.filter(eintrag => {
        if (this.ordermode == "ware" && eintrag.typ == "fisch") {
          return false;
        }
        if (this.ordermode == "fisch" && eintrag.typ == "ware") {
          return false;
        }
        eintrag.searchText = "";
        const searchString = this.search ? this.search.toLowerCase() : "";
        if (!searchString) {
          eintrag.searchText = "";
          return true;
        }
        let foundMatch;
        for (const key in eintrag) {
          if (nonSearchFields.includes(key)) {
            continue;
          } else {
            const value = eintrag[key] || "";
            if (value.toLowerCase().includes(searchString)) {
              if (key === "name_de") {
                const highlightedText = this.highlight(value, searchString);
                eintrag.searchText = `<span class="font-weight-medium">${highlightedText}</span>`;
              } else if (key !== "gruppe") {
                const highlightedText = this.highlight(value, searchString);
                eintrag.searchText = `<span class="font-weight-medium">${eintrag.name_de}<span class="font-weight-regular"> (${highlightedText})</span></span>`;
              }
              foundMatch = true;
              if (key !== "gruppe") {
                return true;
              }
            }
          }
        }
        if (foundMatch) {
          return true;
        }
      });
    },
    headers() {
      return [
        { text: this.$t("label.photo"), value: "foto" },
        {
          text: this.$t("label.name"),
          value: "name_" + this.$route.params.lang
        },
        { text: this.$t("label.group"), value: "gruppe" },
        { text: this.$t("label.type"), value: "typ" }
      ];
    }
  },
  methods: {
    fishFilter(value, search, item) {
      return item["name_" + this.$route.params.lang].includes(search);
    },
    clearSelected() {
      this.$store.commit("bestellungConfig", {
        key: "fish",
        value: ""
      });
    },
    searchString(item) {
      this.search += item;
      this.clearSelected();
    },
    clearSearch() {
      this.search = "";
      this.clearSelected();
    },
    chosen(id, typ) {
      if (typ == "fisch") {
        this.$store.commit("bestellungConfig", {
          key: "fish",
          value: id
        });
        this.$emit("fish-chosen");
      } else {
        this.$store.commit("bestellungConfig", {
          key: "consumable",
          value: id
        });
        this.$emit("goods-chosen");
      }
    },
    highlight,
    updateSortValue
  },
  render() {
    const scopedSlots = {
      item: item => {
        return (
          <tr
            class={
              item.item.id == this.$store.state.bestellungConfig.fish
                ? "selectedTR"
                : ""
            }
            onClick={this.chosen.bind(this, item.item.id, item.item.typ)}
          >
            <td>
              <VImg
                class="ma-1"
                src={item.item.foto || "/img/no-image-placeholder.png"}
                height="80"
                width="80"
                contain
              ></VImg>
            </td>
            <td>
              <span
                domPropsInnerHTML={`<span> ${this.highlight(
                  item.item.searchText
                    ? item.item.searchText
                    : item.item.name_de,
                  this.search
                )}</span>`}
              ></span>
            </td>
            <td>
              <span
                domPropsInnerHTML={`<span> ${this.highlight(
                  item.item.gruppe,
                  this.search
                )}</span>`}
              ></span>
            </td>
            <td>
              <VIcon color="grey">
                {item.item.typ == "fisch"
                  ? "mdi-fish"
                  : "mdi-package-variant-closed"}
              </VIcon>
            </td>
          </tr>
        );
      },
      top: () => {
        return (
          <VTextField
            hide-details
            solo
            append-icon="mdi-magnify"
            v-model={this.search}
            class="customerHeadSearch pa-0 ma-0"
          ></VTextField>
        );
      }
    };
    return (
      <VDataTable
        itemKey="id"
        items={this.filteredList}
        headers={this.headers}
        scopedSlots={scopedSlots}
        disable-pagination
        hide-default-footer
        height="calc(100vh - 125px)"
        sort-by={"name" + this.$route.params.lang}
        fixed-header
        sortBy={this.sortBy}
        sortDesc={this.sortDesc}
        on={{
          "update:sort-by": value =>
            this.updateSortValue(this, "sortBy", value),
          "update:sort-desc": value =>
            this.updateSortValue(this, "sortDesc", value)
        }}
      />
    );
  }
};
